
import React from 'react';
import PropTypes from 'prop-types';
import { Body1 } from '@fluentui/react-components';

import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const GoalCount = ({ numGoals }) =>
  (
    <PropertyRow propertyLabel={{ label: _TL_('Selected goals') }}>
      <Body1 block>{numGoals}</Body1>
    </PropertyRow>
  );
GoalCount.propTypes = {
  numGoals: PropTypes.number.isRequired,
};

